export { default as MedicTemplateActions, types as MedicTemplateTypes } from './actions';
export { default as MedicTemplateSagas } from './sagas';
export { default as MedicTemplateReducers } from './reducers';
